<template>
  <v-container class="pt-0 pr-0 pb-0 pl-0">
    <!-- <v-carousel
      v-model="selected"
      height=288
      :show-arrows="false"
      hide-delimiters>
      <v-carousel-item
        v-for="(image,i) in images"
        :key="i"
        :src="image"
        height=288
        reverse-transition="fade-transition"
        transition="fade-transition">
      </v-carousel-item>
    </v-carousel> -->
    <div class="no-image">
      <img 
        v-if="images[selected]"
        :src="images[selected]"
        alt="Image" />
      <h5 v-else class="category-label">{{ $t('common.noImage') }}</h5>
    </div>
    <v-slide-group multiple class="mt-3">
      <v-slide-item 
        v-for="(image, i) in images"
        :key="i"
        class="mx-1 my-2" 
        :width="width"
        :height="height">
        <div 
          class="thumb-container"
          @click="onClick(i)">
          <img 
            class="thumb-img" 
            :src="image" 
            :width="thumbWidth" 
            :height="thumbHeight" 
            alt="thumb"
            @error="replaceByDefault"
            />
        </div>
      </v-slide-item>
    </v-slide-group>
  </v-container>
</template>

<script>
export default {
  name: "ImageGallery",
  props: {
    images: [],
    thumbWidth: {
      type: Number,
      default: 60
    },
    thumbHeight: {
      type: Number,
      default: 60
    },
  },
  data() {
    return {
      selected: 0
    }
  },
  methods: {
    onClick(index) {
      this.selected = index
    },
    replaceByDefault (e)
    {
      console.log(e)
      e.target.src = "https://via.placeholder.com/30"
    }
  }
}
</script>

<style scoped>
.no-image {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 290px;
  border: thin solid #e0e7ff;
  background-color: rgb(215, 215, 215);
  overflow: hidden;
}

.no-image img {
  height: 288px;
  width: auto;
}

h5 {
  color: rgb(125, 125, 125)
}

.thumb-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
}

.thumb-img {
  border: thin solid #e0e7ff;
}
</style>